// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__eqFjB","button":"Landing_button__otldZ","h3":"Landing_h3__5vtR-","p":"Landing_p__jlsU-"};